module.exports = __webpack_public_path__ + "media/public/images/icon-tooltip-8a978729160499a2c8608b1cb19f36e9.svg";